import { DefaultService } from '@/services/DefaultService';


export default class CargoService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}
    
    findAllCombo(limit = 100, ...params) {
        return this._http.get(`${this._env}/pro/cargo/findallcombo.json?limit=${limit}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    findAll(column, situacao, limit = 50, page = 0, order = 'asc', ...params) {
        return this._http.get(`${this._env}/pro/cargo/findall.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    updateSituacao(obj){
        return this._http.post(`${this._env}/pro/cargo/updatesituacao`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    find(id){
        return this._http.get(`${this._env}/pro/cargo/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    save(obj){
        return this._http.post(`${this._env}/pro/cargo`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}